import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70b5ad4e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=70b5ad4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b5ad4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b5ad4e')) {
      api.createRecord('70b5ad4e', component.options)
    } else {
      api.reload('70b5ad4e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=70b5ad4e&scoped=true", function () {
      api.rerender('70b5ad4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StatisticsDataCardList/index.vue"
export default component.exports